/* Google's documented PUBLIC TEST site key. This preview never verifies a
   token server-side; the widget only gates the local, non-sending form. */
export const RECAPTCHA_SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'

const CALLBACK_NAME = '__kosinsRecaptchaOnload'
const SCRIPT_ID = 'kosins-recaptcha-script'

declare global {
  interface Window {
    grecaptcha?: {
      render: (
        container: HTMLElement,
        params: Record<string, unknown>,
      ) => number
      reset: (widgetId?: number) => void
    }
    __kosinsRecaptchaOnload?: () => void
  }
}

let loadPromise: Promise<void> | null = null

export function loadRecaptcha(): Promise<void> {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('recaptcha-unavailable'))
  }
  if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
    return Promise.resolve()
  }
  if (loadPromise) return loadPromise

  loadPromise = new Promise<void>((resolve, reject) => {
    const timeoutId = window.setTimeout(() => {
      document.getElementById(SCRIPT_ID)?.remove()
      delete window[CALLBACK_NAME]
      loadPromise = null
      reject(new Error('recaptcha-timeout'))
    }, 12000)

    window[CALLBACK_NAME] = () => {
      window.clearTimeout(timeoutId)
      resolve()
    }

    const existing = document.getElementById(SCRIPT_ID)
    if (existing) return

    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.src = `https://www.google.com/recaptcha/api.js?onload=${CALLBACK_NAME}&render=explicit`
    script.async = true
    script.defer = true
    script.onerror = () => {
      window.clearTimeout(timeoutId)
      script.remove()
      loadPromise = null
      reject(new Error('recaptcha-failed'))
    }
    document.head.appendChild(script)
  })

  return loadPromise
}
